export * from './floating-panel.component';
